// ============================================
// タイトル関連の共通定数
// ============================================

export type TitleCode = 'GC' | 'SNC' | 'NC' | 'SLC' | 'IC' | 'BC' | 'FC' | 'SPC'

export type TitleBadgeClass =
  | 'tc-title-gc'
  | 'tc-title-snc'
  | 'tc-title-nc'
  | 'tc-title-slc'
  | 'tc-title-ic'
  | 'tc-title-bc'
  | 'tc-title-fc'
  | 'tc-title-spc'

export interface TitleInfo {
  id: number
  code: TitleCode
  name: string
  className: TitleBadgeClass
}

// タイトルID → 略称
export const TITLE_ID_TO_CODE: Record<number, TitleCode> = {
  1: 'SPC',
  2: 'FC',
  3: 'BC',
  4: 'IC',
  5: 'SLC',
  6: 'NC',
  7: 'SNC',
  8: 'GC',
}

// 略称 → タイトルID
export const TITLE_CODE_TO_ID: Record<TitleCode, number> = {
  SPC: 1,
  FC: 2,
  BC: 3,
  IC: 4,
  SLC: 5,
  NC: 6,
  SNC: 7,
  GC: 8,
}

// タイトルID → タイトル名
export const TITLE_NAMES: Record<number, string> = {
  1: 'スパーク・コネクター',
  2: 'フレイム・コネクター',
  3: 'ブレイズ・コネクター',
  4: 'インフェルノ・コネクター',
  5: 'スターライト・コネクター',
  6: 'ノヴァ・コネクター',
  7: 'スーパーノヴァ・コネクター',
  8: 'ギャラクシー・コネクター',
}

// タイトル略称 → 詳細情報
export const TITLE_INFO_MAP: Record<TitleCode, TitleInfo> = {
  GC: { id: 8, code: 'GC', name: 'ギャラクシー・コネクター', className: 'tc-title-gc' },
  SNC: { id: 7, code: 'SNC', name: 'スーパーノヴァ・コネクター', className: 'tc-title-snc' },
  NC: { id: 6, code: 'NC', name: 'ノヴァ・コネクター', className: 'tc-title-nc' },
  SLC: { id: 5, code: 'SLC', name: 'スターライト・コネクター', className: 'tc-title-slc' },
  IC: { id: 4, code: 'IC', name: 'インフェルノ・コネクター', className: 'tc-title-ic' },
  BC: { id: 3, code: 'BC', name: 'ブレイズ・コネクター', className: 'tc-title-bc' },
  FC: { id: 2, code: 'FC', name: 'フレイム・コネクター', className: 'tc-title-fc' },
  SPC: { id: 1, code: 'SPC', name: 'スパーク・コネクター', className: 'tc-title-spc' },
}

// 最大タイトルID (GC)
export const MAX_TITLE_ID = 8

// ユニレベル対象の最小タイトルID (IC)
export const FIRST_UNILEVEL_TITLE_ID = 4

// タイトルID → CSSクラス (conditionJudgment.ts互換)
export const TITLE_CSS_CLASSES: Record<number, string> = {
  1: 'title-spc',
  2: 'title-fc',
  3: 'title-bc',
  4: 'title-ic',
  5: 'title-slc',
  6: 'title-nc',
  7: 'title-snc',
  8: 'title-gc',
}

// タイトルID → 略称 (conditionJudgment.ts互換)
export const TITLE_ABBREVIATIONS: Record<number, string> = TITLE_ID_TO_CODE
